/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type { GetUsersOptions, GetUsersResponses } from '../types/GetUsers'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @summary Get all users (admin only)
 * {@link /v1/user}
 */
export function getUsers<ThrowOnError extends boolean = true>(
  options: Options<GetUsersOptions, ThrowOnError> = {},
): Unwrappable<RequestResult<GetUsersResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'GET',
      url: '/v1/user',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<GetUsersResponses, ThrowOnError>>,
  )
}
